import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AgentDashboard from "./pages/AgentDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Shop from "./pages/Shop";
import PaymentResult from "./pages/PaymentResult";
import MobileAdmin from "./pages/MobileAdmin";
import Contatti from "./pages/Contatti";
import ChiSiamo from "./pages/ChiSiamo";
import Comodato from "./pages/Comodato";
import LabelsIndex from "./pages/LabelsIndex";
import LabelPage from "./pages/LabelPage";
import ProductPage from "./pages/ProductPage";
import GuidePage from "./pages/GuidePage";
import NewsletterUnsubscribe from "./pages/NewsletterUnsubscribe";
import Register from "./pages/Register";
import Account from "./pages/Account";
import ListinoB2B from "./pages/ListinoB2B";
import AgentMobile from "./pages/AgentMobile";
import AppEntry from "./pages/AppEntry";
import ListinoPublic from "./pages/ListinoPublic";
import AuthCallback from "./pages/AuthCallback";
import ImpersonationBanner from "./components/ImpersonationBanner";
import SeoHead from "./components/SeoHead";
import { useAuth } from "./context/AuthContext";

function OAuthGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return <><SeoHead /><ImpersonationBanner />{children}</>;
}

function ListinoGate() {
  const { user } = useAuth();
  if (user === undefined || user === false) return <ListinoPublic />;
  return <ProtectedRoute roles={["b2b"]}><ListinoB2B /></ProtectedRoute>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <OAuthGate>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/negozio" element={<Shop />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/comodato" element={<Comodato />} />
            <Route path="/ingredienti" element={<LabelsIndex />} />
            <Route path="/ingredienti/:slug" element={<LabelPage />} />
            <Route path="/prodotto/:slug" element={<ProductPage />} />
            <Route path="/guida" element={<GuidePage />} />
            <Route path="/newsletter/disiscrizione" element={<NewsletterUnsubscribe />} />
            <Route path="/guida/:slug" element={<GuidePage />} />
            <Route path="/pagamento-esito" element={<PaymentResult />} />
            <Route path="/accedi" element={<Login />} />
            <Route path="/registrati" element={<Register />} />
            <Route path="/account" element={<ProtectedRoute roles={["customer", "b2b"]}><Account /></ProtectedRoute>} />
            <Route path="/listino" element={<ListinoGate />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/agente" element={<ProtectedRoute role="agent"><AgentDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/mobile" element={<ProtectedRoute role="admin"><MobileAdmin /></ProtectedRoute>} />
            <Route path="/agente-mobile" element={<ProtectedRoute role="agent"><AgentMobile /></ProtectedRoute>} />
            <Route path="/app" element={<AppEntry />} />
          </Routes>
          </OAuthGate>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
